angular.module('geocoderService', ['constants'])
.factory('geocoderService', function($http, $q, myConfig) {

  var service = {};

  /*
  * send oblist
  */
  service.getCountry = function(lat,lon){
    var deferred = $q.defer();
    // complete url
    var url = 'http://nominatim.openstreetmap.org/reverse?format=json&lat='+lat+'&lon='+lon;
    // send
    $http({
      method  : 'GET',
      url: url
    }).then(function(response){
      if (response.data.address){
        deferred.resolve(response.data.address.country_code);
      } else {
        deferred.resolve({error:'data not retrieved'});
      }      
    })
    return deferred.promise;
  }

  return service;

});
